import { ref } from "vue";
export function useSideMenu() {
  const collapsed = ref(localStorage.getItem("sideMenu.collapse") === "true");
  function updateCollapsed(newValue: boolean) {
    localStorage.setItem("sideMenu.collapse", newValue.toString());
  }
  return { collapsed, updateCollapsed };
}
